import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@root/src/environments/environment';

/** One process in the 30-day reliability snapshot. */
export interface ProcessReliabilityRow {
  processKey: string;
  failed: number;
  succeeded: number;
  notReacting: string[];
}

/** Broken and intermittent processes plus people who left failure notices unread. */
export interface ProcessReliabilitySnapshot {
  generatedAt: string;
  from: string;
  broken: ProcessReliabilityRow[];
  intermittent: ProcessReliabilityRow[];
}

/**
 * Reliability board for the orchestration overview.
 * TODO: migrate to api-client when monitoringProcessReliabilityGet is generated.
 */
@Injectable({ providedIn: 'root' })
export class OrchestrationProcessReliabilityService {
  private readonly http = inject(HttpClient);

  load(): Observable<ProcessReliabilitySnapshot> {
    return this.http.get<ProcessReliabilitySnapshot>(
      `${environment.api}/monitoring/process-reliability`,
    );
  }
}
